'use strict';

import ReAuthView from 'standard-vote/app/scripts/views/reauth.js';

module.exports = ReAuthView;



// WEBPACK FOOTER //
// ./app/scripts/views/reauth.js